<template>
    <!-- 轮播图广告组件 -->
    <div class="bannerModule" :class="{roundBorder8 : isRoundBorder}" style="overflow: hidden" v-show="adList.length > 0 || isShowBanner">
        <slider ref="slider" :options="sliderOptions">
            <!-- 直接使用slideritem slot -->
            <slideritem class="bannerItem" v-for="(item,index) in adList" :key="index">
                <div @click="clickAd(item)">
                    <img class="block fullSpace cover" :src="item.img" alt=""/>
                </div>
            </slideritem>
            <!-- 设置loading,可自定义 -->
            <div class="" slot="loading">
                <div class="alignCenter">loading...</div>
            </div>
        </slider>
    </div>
</template>

<script>
// modules
import { slider, slideritem } from 'vue-concise-slider';

// part
import adModulePart     from '@comp/ad/adModulePart';

// config
import appConfig from '../appConfig';

// util
import appHelper        from '@util/appHelper';

const config = {
    apiConfig : {
        list : {
            url : "portal/advertis/getAdvertisByType",
            dataPath : 'data'
        }
    }
};

export default {
    name: "bannerModule",
    extends : adModulePart,
    components: {
        slider, slideritem
    },
    props:{
        isShowBanner:{
            type:Boolean,
            default:true,
        },
        isRoundBorder : {
            type:Boolean,
            default:true,
        }
    },
    data() {
        return {
            apiConfig : config.apiConfig,
            sliderOptions: {
                autoplay: 3 * 1000,
                loop:true,
                // direction:'vertical',
                speed: 600
            }
        }
    },
    mounted() {

        // demo data
        if (appConfig.mode == 'demo')
        {
            for (let i=0; i<=2; i++)
            {
                this.adList.push({
                    id : i,
                    image : appHelper.getRandomCoverImage(),
                    link : 'javascript:;'
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bannerModule {

    .bannerItem {
        overflow: hidden;
    }
}
</style>
